module.exports = __webpack_public_path__ + "static/media/la-corporate-catering-3.eda31f74.jpg";